import Cookies from 'js-cookie';
import { generateUUID } from '@cbhq/client-analytics';

type CookieKrisp = {
  deviceId: string;
  userId?: string | null;
  cbChat?: string | null;
};
export function getCookieInfo(): CookieKrisp {
  const deviceIdKey = 'coinbase_device_id';
  let deviceId = Cookies.get(deviceIdKey);
  const userId = Cookies.get('user_id');

  if (!deviceId) {
    Cookies.set(deviceIdKey, (deviceId = generateUUID()));
  }
  return { deviceId, userId };
}
